export const ROUTES = {

    // DUEL KEYS
    GLOBAL: {
        GLOBAL: "global.global",
        DOCS : "global.docs",
        CLASSFILE: "global.classfile",
        INVENTORY: "global.inventory",
        MAINTENANCE: "global.maintenance",
        EMPLOYEE_LOGIN: "global.employee_login",
        REQUEST_CLERK_CODE: "global.request_clerk_code",
        SETUP: "global.setup",
        SETUP_PASSWORDS: "global.setup_passwords",
        SETUP_PASSWORDS_RIGHT: "global.setup_passwords_right",
        SETUP_TAXCODES: "global.setup_taxcodes",
        SETUP_TAXCODES_RIGHT: "global.setup_taxcodes_right",
        SETUP_TAXCODES_NEW: "global.setup_taxcodes_new",
        SETUP_TAXCODES_SEARCH: "global.setup_taxcodes_search",
        SETUP_TAXCODES_NEW: "global.setup_taxcodes_new",
        SETUP_TAXTYPES_NEW_TYPE: "global.setup_taxcodes_new_type"
    },

    AUTHENTICATION: {
        LOGIN: "authentication.login",
        LOGOUT: "authentication.logout",
        STORES: "authentication.stores",
    },
    EMPLOYEE: {
        EDIT: "employee.edit"
    },
    HOME: {
        MENU: "home.menu",
        STATIONS: "home.stations",
        TOOLS: "home.tools"
    },
    POS: {
        POS: "pos.pos",
        EDIT: "pos.edit",
        CUSTOMER: "pos.customer",
        SEARCH_ISBN : "pos.search_isbn"
    },
    GL: {
        GL: "gl.gl",
        ACCOUNTS: "gl.accounts"
    },
    REPORTS: {
        REPORTS: "reports.reports",
        CUSTOM_INVENTORY: "reports.custom_inventory",
        CUSTOM_INVENTORY_GROUPS: "reports.custom_inventory_groups",
        CUSTOM_EDIT: "reports.custom_edit",
        COLUMNS: "reports.columns",
        FILTER: "reports.filter",
        FILTER_SELECT: "reports.filter_select",
        FILTER_EDIT: "reports.filter_edit",
        FILTER_SALES_IN: "reports.filter_sales_in",
        FILTER_INVOICES_BETWEEN: "reports.filter_invoices_between",
        FILTER_INVENTORY_BETWEEN: "reports.filter_inventory_between",
        SEARCH : "reports.search"
    },
    CUSTOMER: {
        CUSTOMER: "customer.customer",
        EDIT: "customer.edit",
        HISTORY: "customer.history",
        DETAILS: "customer.details",
        SEARCH: "customer.search",
        AR: "customer.ar",
        AR_TOTAL: "customer.ar_total"
    },
    ORDERS: {
        ORDERS: "orders.orders",
    },
    PROCESSING: {
        PROCESSING: "processing.processing",
        ORDER_TOTALS_BY_SECTION: "processing.ordertotalsbysection",
        UPDATE: "processing.update"
    },
    INVENTORY: {
        INVENTORY: 'inventory.inventory',
        EDIT: "inventory.edit",
        SEARCH: "inventory.search",
        SORT: "inventory.sort",
        RESERVE: "inventory.reserve",
        RESERVE_FORM: "inventory.reserve_form",
        EXTRA: "inventory.extra",
        MESSAGE: "inventory.message",
        AUTHORPICKER: "inventory.authorpicker",
        AUTHORPICKER_TITLE: "inventory.authorpicker_title",
        HISTORY: "inventory.history",
        ADJUST: "inventory.adjust",
        PUBSTOCK: "inventory.pubstock",
        ORDERS: "inventory.orders",
        ORDERS_EDIT : "inventory.orders_edit",
        ORDER: "inventory.order",
        LABELS : "inventory.labels",
    },
    SUPPLIERS: {
        SUPPLIERS: "suppliers.suppliers"
    },
    RECONCILIATION: {
        RECONCILIATION: "reconciliation.reconciliation",
        ADJUST: "reconciliation.adjust",
        COUNT: "reconciliation.count",
        NEW: "reconciliation.new",
        SEARCH: "reconciliation.search",
        EXTRA: "reconciliation.extra",
        SOUNDS: "reconciliation.sounds",
        EXPORT_COUNTS: "reconciliation.export_counts",
        RESET_INVENTORY: "reconciliation.reset_inventory",
        FIND_INVENTORY: "reconciliation.find_inventory",
        PURGE_LIST: "reconciliation.purge_list",
        ZERO_COUNTS: "reconciliation.zero_counts",
        IMPORT: "reconciliation.import",
        VIEW_FILE: "reconciliation.view_file",
        VIEW_FILE_SEARCH: "reconciliation.view_file_search",
        FIND_ISBNS: "reconciliation.find_isbns",
        HISTORY: "reconciliation.history"
    },
    HISTORY: {
        FILTERS: "history.filters",
        ORDER_TRACK: "order_track"
    },
    HELPERS: {
        TAGS: "helpers.tags",
        CUSTOMER_NAME: "helpers.customer_name",
        CUSTOMER_SELECT: "helpers.customer_select",
        CUSTOMER_TYPES: "helpers.customer_types",
        CLASS_SELECTOR: "helpers.class_selector",
        USED_CONDITIONS: "helpers.used_conditions",
        BINDINGS: "helpers.bindings",
        CONDITIONS: "helpers.conditions",
        NOTE_INDICATORS: "helpers.note_indicators",
        BISACS: "helpers.bisacs",
        BISACS_RIGHT: "helpers.bisacs_right",
        OS_STATS: "helpers.out_of_order_status",
        TITLELINK_SEARCH: "helpers.titlelink_search",
        TITLELINK_SETTINGS : "helpers.titlelink_settings",
        PICKER: "helpers.picker",
        TITLELINK_DATA: "helpers.titlelink_data",
        CONFIRM: "helpers.confirm",
        HELP: "helpers.help",
        OPTIONS: "helpers.options",
        INFO: "helpers.info",
        WORKSTATION: "helpers.workstation",
        POPUP: "helpers.popup",
        PROMPT: "helpers.prompt"
    },
    MISC: {
        SELECTOR: "misc.selector",
        TEST : "misc.test",
        TEST_DETAILS : "misc.test_details"
    },
    MAIN: "main"

}